module.exports = __webpack_public_path__ + "img/RORBPJR40044.20dce4f5.png";